import { FormControlLabel, Radio, styled, TextField } from '@mui/material';
import { FormLabel } from '../components/FormLabel';
import { previousProfessionType } from './types';

function PreviousProfession(props: {
    previousProfession: previousProfessionType | undefined;
    setPreviousProfession: (setPreviousProfession: previousProfessionType) => void;
}) {
    const { previousProfession, setPreviousProfession } = props;
    return (
        <Container>
            <Row>
                <FormLabel label="Avez-vous déjà exercé une profession ?" />
                <FormControlLabel
                    control={<Radio checked={previousProfession?.kind === 'yes'} />}
                    onChange={() => setPreviousProfession({ kind: 'yes', description: '' })}
                    label="Oui"
                    name="previous-profession-yes"
                />
                <FormControlLabel
                    control={<Radio checked={previousProfession?.kind === 'no'} />}
                    onChange={() => setPreviousProfession({ kind: 'no' })}
                    label="Non"
                    name="previous-profession-no"
                />
            </Row>
            {!!previousProfession && previousProfession.kind === 'yes' && (
                <Row>
                    <FormLabel label="Laquelle ?" />
                    <TextField
                        name="description"
                        label="Préciser la profession"
                        fullWidth
                        required
                        value={previousProfession.description}
                        onChange={(event) =>
                            setPreviousProfession({
                                ...previousProfession,
                                description: event.target.value,
                            })
                        }
                    />
                </Row>
            )}
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({}));
const Row = styled('div')(({ theme }) => ({ display: 'flex', alignItems: 'center' }));

export { PreviousProfession };
